export function hasValidCoordinate(lat, lng) {
  return (
    typeof lat === "number" &&
    typeof lng === "number" &&
    Number.isFinite(lat) &&
    Number.isFinite(lng) &&
    lat >= -90 &&
    lat <= 90 &&
    lng >= -180 &&
    lng <= 180
  );
}

export function buildMapsNavigationUrl({ lat, lng, address, restaurant_name: restaurantName } = {}) {
  let destination = "";

  if (hasValidCoordinate(lat, lng)) {
    destination = `${lat},${lng}`;
  } else if (address) {
    destination = restaurantName ? `${restaurantName}, ${address}` : address;
  } else if (restaurantName) {
    destination = restaurantName;
  }

  if (!destination) return null;

  return `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(destination)}`;
}
